(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dd-how-it-works"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.dd-how-it-works__upsell-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var variantId = btn.dataset.variantId;
        if (!variantId) return;
        window.ddAddToCart(variantId, 1, btn, function(data, b, original) {
          b.textContent = 'Added!';
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          setTimeout(function() { b.textContent = original; b.disabled = false; }, 2000);
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
